// Module
var code = `<template> <div class="button-icon \${disabled ? 'disabled':''}" tabindex.bind="tab" click.trigger="onClick(\$event)"> <slot> <i class="button-icon-value" if.bind="!loading">\${icon}</i> </slot> <loading class="small color-white" if.bind="loading"></loading> </div> </template> `;
// Exports
module.exports = code;